import { graphql } from '@eluve/graphql.tada';

// Mutations

export const addAppointmentBillingCodeLinksMutation = graphql(`
  mutation insertAppointmentBillingCodeLinks(
    $billingCodeLinks: [AppointmentBillingCodeLinksInsertInput!]!
  ) {
    insertAppointmentBillingCodeLinks(objects: $billingCodeLinks) {
      returning {
        __typename
        id
        sourceAppointmentBillingCodeId
        targetAppointmentBillingCodeId
      }
    }
  }
`);

export const removeAppointmentBillingCodeLinksMutation = graphql(`
  mutation removeAppointmentBillingCodeLinks(
    $tenantId: uuid!
    $appointmentId: uuid!
    $sourceBillingCodeId: uuid!
    $targetBillingCodeIds: [uuid!]!
  ) {
    deleteAppointmentBillingCodeLinks(
      where: {
        tenantId: { _eq: $tenantId }
        appointmentId: { _eq: $appointmentId }
        sourceAppointmentBillingCodeId: { _eq: $sourceBillingCodeId }
        targetAppointmentBillingCodeId: { _in: $targetBillingCodeIds }
      }
    ) {
      returning {
        __typename
        id
        sourceAppointmentBillingCodeId
        targetAppointmentBillingCodeId
      }
    }
  }
`);

export const updateAppointmentBillingCodeModifiersMutation = graphql(`
  mutation updateAppointmentBillingCodeModifiers(
    $billingCodeId: uuid!
    $modifiers: jsonb
  ) {
    updateAppointmentBillingCodesByPk(
      pkColumns: { id: $billingCodeId }
      _set: { modifiers: $modifiers }
    ) {
      __typename
      id
      modifiers
    }
  }
`);

export const updateAppointmentBillingCodePriceMutation = graphql(`
  mutation updateAppointmentBillingCodePrice(
    $billingCodeId: uuid!
    $price: Int!
  ) {
    updateAppointmentBillingCodesByPk(
      pkColumns: { id: $billingCodeId }
      _set: { price: $price }
    ) {
      __typename
      id
      price
    }
  }
`);

export const updateAppointmentBillingCodeQuantityMutation = graphql(`
  mutation updateAppointmentBillingCodeQuantity(
    $billingCodeId: uuid!
    $quantity: Int!
  ) {
    updateAppointmentBillingCodesByPk(
      pkColumns: { id: $billingCodeId }
      _set: { quantity: $quantity }
    ) {
      __typename
      id
      quantity
    }
  }
`);
